import React, { useState, useEffect } from 'react';
import { Button } from '../../components/ui/button';
import { Loader2, Save } from 'lucide-react';
import { TextField } from './FieldKit';

export default function StepIdentity({ step, state, onSave, saving }) {
  const [draft, setDraft] = useState(state.answers || {});
  useEffect(() => { setDraft(state.answers || {}); }, [state]);
  const set = (k, v) => setDraft((d) => ({ ...d, [k]: v }));

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-5 space-y-4" data-testid="onboarding-step-identity">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {step.fields.map((f) => (
          <TextField key={f.key} field={f} value={draft[f.key]} onChange={set} testIdPrefix="onb-identity" />
        ))}
      </div>
      <div className="flex justify-end pt-2">
        <Button onClick={() => onSave(draft)} disabled={saving} data-testid="onb-identity-save">
          {saving ? <Loader2 className="h-3.5 w-3.5 mr-2 animate-spin" /> : <Save className="h-3.5 w-3.5 mr-2" />}
          Save & continue
        </Button>
      </div>
    </div>
  );
}
